export enum EmojiEnum {
  Sad = 'SAD',
  Ok = 'OK',
  Happy = 'HAPPY',
}

// ref: https://codepen.io/suhani-ashok/pen/RwRrzGN
//need to render this whererver emojis are used
export const baseEmojisSVGs = (
  <svg className="hidden" xmlns="http://www.w3.org/2000/svg">
    <symbol id="eye" viewBox="0 0 7 4" xmlns="http://www.w3.org/2000/svg">
      <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1" />
    </symbol>
    <symbol id="mouth" viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg">
      <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5" />
    </symbol>
  </svg>
);

export const emojis = {
  [EmojiEnum.Sad]: {
    id: EmojiEnum.Sad,
    node: (
      <div>
        <svg className="eye left">
          <use href="#eye" />
        </svg>
        <svg className="eye right">
          <use href="#eye" />
        </svg>
        <svg className="mouth">
          <use href="#mouth" />
        </svg>
      </div>
    ),
    className: 'sad',
  },
  [EmojiEnum.Ok]: {
    id: EmojiEnum.Ok,
    node: <div />,
    className: 'ok',
  },
  [EmojiEnum.Happy]: {
    id: EmojiEnum.Happy,
    node: (
      <div>
        <svg className="eye left">
          <use href="#eye" />
        </svg>
        <svg className="eye right">
          <use href="#eye" />
        </svg>
      </div>
    ),
    className: 'happy',
  },
};
